<template>
  <LibraryLayout :title="'Game Library'" :items="games">
    <template slot="button">
      <v-btn v-if="authUser" @click="createGame" color="blue" dark class="elevation-0">
        <v-icon left>mdi-creation-outline</v-icon> Create Game
      </v-btn>
      <v-btn v-else @click="go('LoginView')" color="blue" dark class="elevation-0">
        <v-icon left>mdi-lock-outline</v-icon> Create Game
      </v-btn>
    </template>
    <template #card="{ item: game }">
      <v-card class="ma-2" width="300">
        <div @click="go('GamePlayer', game.id)" style="cursor: pointer;">
          <v-img :src="game.thumbnail" color="grey lighten-4" height="200"></v-img>
          <v-divider></v-divider>
          <div class="px-4 pt-4 cal-sans-regular font-size-20">{{ game.title }}</div>
          <div class="d-flex flex-row align-center px-4 pb-4 pt-2">
            <v-avatar size="30">
              <v-img src="@/assets/babyboomy.png"></v-img>
            </v-avatar>
            <p class="ma-0 ml-2">{{ game.creator || 'Baby Boomy?' }}</p>
          </div>
        </div>
        <v-card-actions v-if="authUser">
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <v-btn icon small @click="riffGame(game.id)" color="primary">
                  <v-icon>mdi-music-note</v-icon>
                </v-btn>
              </span>
            </template>
            <span>Create a Riff</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </template>
  </LibraryLayout>
</template>

<script>
import { getDocs, collection, query, where } from 'firebase/firestore' // Ensure 'query' and 'where' are imported
import { db } from '@/firebase/init'
import LibraryLayout from '@/layouts/Library.vue'

export default {

  name: 'GameLibrary',

  components: {
    LibraryLayout,
  },

  data() {
    return {
      games: [],
      progress: 0,
    }
  },

  created() {
    this.loadGames()
  },

  methods: {
    loadGames() {
      this.progress = 0
      this.games = [] // Clear existing games before loading
      const gamesCollection = collection(db, 'games')
      const q = query(gamesCollection, where("state", "==", "public")) // Create the query
      getDocs(q).then((snapshot) => { // Use the query 'q'
        snapshot.forEach((doc) => {
          let game = doc.data()
          game.id = doc.id
          this.games.push(game)
        })
        this.progress = 100
      }).catch(error => {
        console.error("Error loading public games:", error);
        this.progress = 100; // Still complete progress to avoid UI hanging
      });
    },

    async createGame() {
      if (this.authUser) {
        await this.$creator.create('game', this.profile);
      }
    }
  }
}
</script>

<style scoped>

</style>